import { render, staticRenderFns } from "./propertyList.vue?vue&type=template&id=5aad048a&scoped=true"
import script from "./propertyList.vue?vue&type=script&lang=js"
export * from "./propertyList.vue?vue&type=script&lang=js"
import style0 from "./propertyList.vue?vue&type=style&index=0&id=5aad048a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad048a",
  null
  
)

export default component.exports